import { createFileRoute, Outlet, useNavigate, useParams } from "@tanstack/react-router";
import { useEffect, useState } from "react";
import { OrgAccessRecovery } from "~/components/OrgAccessRecovery";
import { useOrg } from "~/contexts/org-context";
import { useAuthContext } from "~/contexts/auth-context";
import { useUserOrganizations } from "~/lib/queries/users";
import { useBestAvailableOrg } from "~/hooks/use-best-avalible-org";

export const Route = createFileRoute("/org/$org")({
  component: RouteComponent,
});

function RouteComponent() {
  const { activeOrg, isLoading, error, activeOrgId, isAdminMode } = useOrg();
  const { org: urlOrgId } = useParams({ from: "/org/$org" });
  const { isAuthenticated, isLoading: authLoading } = useAuthContext();
  const { data: userOrgs, isLoading: orgsLoading } = useUserOrganizations();
  const bestOrgId = useBestAvailableOrg();
  const navigate = useNavigate();
  const [hasAttemptedRecovery, setHasAttemptedRecovery] = useState(false);

  const allLoading = isLoading || authLoading || orgsLoading;

  useEffect(() => {
    if (allLoading || hasAttemptedRecovery || activeOrg) return;
    if (isAdminMode) return;

    if (!error && !activeOrg && userOrgs && bestOrgId && bestOrgId !== urlOrgId) {
      setHasAttemptedRecovery(true);
      navigate({ to: "/org/$org", params: { org: bestOrgId }, replace: true });
    }
  }, [allLoading, activeOrg, error, userOrgs, bestOrgId, urlOrgId, hasAttemptedRecovery, navigate, isAdminMode]);

  if (allLoading && !isAdminMode) {
    return <div className="flex h-full items-center justify-center"><div>Loading...</div></div>;
  }

  if (activeOrg || isAdminMode) {
    return <Outlet />;
  }

  return (
    <OrgAccessRecovery
      attemptedOrgId={urlOrgId}
      userOrgs={userOrgs ?? []}
      bestOrgId={bestOrgId}
      isAuthenticated={isAuthenticated}
      error={error}
    />
  );
}
